module.exports=function(scope){ return `{
    "data": {
        "glasses": false,
        "sessionTokenStatus": 0,
        "faceMapType": 0,
        "ageEstimateGroup": 4,
        "livenessStatus": 0,
        "auditTrailVerificationCheck": 0,
        "isLowQuality": false,
        "auditTrailMatchCheck": 0,
        "isReplayFaceMap": true
    },
    "meta": {
        "code": 200,
        "message": "The FaceMap is estimated to be 30 or over.",
        "ok": true,
        "m": {
            "prepareAndUpdateTimeInMS": ...,
            "estimateAgeTimeInMS": ...,
            "totalDurationInMS": ...
        }
    }
}`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/success/estimate-age.json.tpl